var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nep/phone_number/index.js
 ** module id = 792
 ** module chunks = 0
 **/